import React, { forwardRef, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Input } from "./Field";

// Password field with a show/hide toggle. Pass `shown` + `onToggle` to share
// one toggle between "password" and "confirm password".
const PasswordInput = forwardRef(({ shown, onToggle, ...rest }, ref) => {
  const [own, setOwn] = useState(false);
  const visible = shown ?? own;
  const toggle = onToggle || (() => setOwn((v) => !v));
  return (
    <div className="relative">
      <Input
        ref={ref}
        ltr
        type={visible ? "text" : "password"}
        className="pl-12"
        {...rest}
      />
      <button
        type="button"
        onClick={toggle}
        className="absolute left-2 top-1/2 -translate-y-1/2 p-2 rounded-lg text-white/50 hover:text-white"
        aria-label={visible ? "إخفاء كلمة المرور" : "إظهار كلمة المرور"}
      >
        {visible ? <FaEyeSlash /> : <FaEye />}
      </button>
    </div>
  );
});

export default PasswordInput;
